module.exports = __webpack_public_path__ + "static/stats-de81eca1e347cfe548f1bf27edba4099.png";